// Navegação com histórico (voltar/avançar), como num navegador.
// Rotas: {view: "home"} | {view: "page", id} | {view: "settings"} | {view: "inbox"} | {view: "tasks"}
// | {view: "ai", q?, workspace?, voice?} | {view: "admin"} | {view: "team", id?}

import { safeGet, safeSet } from "./dom.js";

const stack = [];
let index = -1;
let renderFn = null;

export function setRenderer(fn) {
  renderFn = fn;
}

export const current = () => stack[index] || { view: "home" };
export const canBack = () => index > 0;
export const canForward = () => index < stack.length - 1;

const same = (a, b) => a && b && a.view === b.view && a.id === b.id && a.q === b.q && a.workspace === b.workspace && a.voice === b.voice;

export function go(route, { replace = false } = {}) {
  if (same(route, current()) && index >= 0) {
    renderFn?.(route, { same: true });
    return;
  }
  if (replace && index >= 0) stack[index] = route;
  else {
    stack.splice(index + 1);
    stack.push(route);
    if (stack.length > 100) stack.shift();
    index = stack.length - 1;
  }
  safeSet("ordo.lastRoute", route);
  renderFn?.(route, {});
}

export function back() {
  if (!canBack()) return;
  index--;
  safeSet("ordo.lastRoute", current());
  renderFn?.(current(), { history: true });
}

export function forward() {
  if (!canForward()) return;
  index++;
  safeSet("ordo.lastRoute", current());
  renderFn?.(current(), { history: true });
}

// Remove do histórico uma página que deixou de existir.
export function forget(id) {
  for (let i = stack.length - 1; i >= 0; i--) {
    if (stack[i].id === id) {
      stack.splice(i, 1);
      if (index >= i) index--;
    }
  }
  index = Math.max(0, Math.min(index, stack.length - 1));
}

export const lastRoute = () => safeGet("ordo.lastRoute", { view: "home" });

export const openPage = (id, opts) => go({ view: "page", id }, opts);
